import React, { useCallback, useState } from 'react';
import { MenuConfig, NestedMenu } from './ContextMenu/NestedMenu';
import useOutsideClick from '../../helpers/hooks/UseOutsideClick';
import { Button } from '../atoms/Button';
import { SizeVariants } from '../../theme/themes';

export interface EllipsisMenuProps {
  menu: MenuConfig;
  onClose?: () => void;
}

export const EllipsisMenu = (props: EllipsisMenuProps) => {
  const { menu, onClose } = props;
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);

  /** close all menus */
  const closeMenu = useCallback(() => {
    setOpen(false);
    onClose?.();
  }, [onClose]);

  const toggleMenu = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const rootRef = useOutsideClick(closeMenu);

  return (
    <div ref={rootRef}>
      <Button
        iconLeft="more"
        buttonStyle="ghost"
        size={SizeVariants.sm}
        onClick={toggleMenu}
        ref={setAnchor}
      />
      <NestedMenu
        menuConfig={menu}
        onClose={closeMenu}
        anchor={anchor}
        open={open}
      />
    </div>
  );
};
